module.exports = __webpack_public_path__ + "static/media/writing2.a742236a.gif";